<div [innerHtml]="jsonLDPQR"></div>
<div class="layout_content m-t" id="layout-top">
    <app-breadcrumb></app-breadcrumb>
    <div class="pqr">
        <div class="top_info">
            <div class="container">
                <div class="logo">
                    <img src="./assets/img/brand/logo_jelpit_blanco.svg" alt="Jelpit">
                </div>
                <h2 class="title">Preguntas frecuentes</h2>
                <div class="form_search">
                    <div class="grid">
                        <div class="form_item grid-12">
                            <input [(ngModel)]="textSearch" (input)="resetSetting()" type="text" placeholder="Buscar" autocomplete="off">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="results_container">
        <div class="container">
            <div class="list_results">
                <div class="item" *ngFor="let result of listFaq | searcher: textSearch : 'name'| slice:paginationStart:paginationEnd">
                    <h5 class="title_result">{{result.name}}</h5>
                    <div class="text_pqr" [innerHtml]="result.description"></div>
                </div>
            </div>
        </div>
    </div>
    <app-pagination [numberPagination]="listFaq.length" [dataForPage]="dataForPage" *ngIf="listFaq.length > dataForPage && textSearch.length < 3" (sendEndPageStartPage)="pagination($event)">
    </app-pagination>
</div>